import { useContext, useEffect, useMemo, useState } from "react";
import {
  BoxFull,
  Button,
  TreeSelection,
} from "iuvity-ui-components";
import {
  CustomDialog,
  DialogProps,
} from "../../components/dialog/CustomDialog";
import { AppContext } from "../../context/index";
import { useApplications } from "../../hooks/useApplications";
import { AppInfo, DataBranding } from "../../interfaces";
import { getAgent } from "../../services/console/agent";
import IBModuleApi from "../../api/iuviBankingAPI";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { SettingsUsed } from "../../components/shared/SettingsUsed";
import { LastChangesTable } from "../../components/shared/LastChangesTable";
import { useTenantBranding } from "../../hooks/useTenantBranding";
import { useQuickLinksConsole } from "../../hooks/useQuickLinksConsole";
import { useUserRole } from "../../hooks/useUserRole";
import { useTenants } from "../../hooks/useTenants";
import { useAudit } from "../../hooks/useAudit";
import { PanelMenu } from "primereact/panelmenu";
import { auth } from "../../services/iam/auth";

export const SelectApplicationPage: React.FC<any> = () => {
  const {
    t,
    toast,
    appState: { language, isParentTenant, tenantIdListsNavigations, tenantId, hasApplications },
    setAppState,
  } = useContext(AppContext);
  // PERMITE MOSTRAR LA ALERTA DE AMBIENTE CUANDO SE CAMBIA DE APLICACIÓN
  sessionStorage.removeItem("ENVIRONMENT::ALERT");

  const objSegments: any = {}
  const objTypesSegments: any = {}
  const objTypesEnvironments: any = {}
  const objTypesRoles: any = {}

  const { data: applicationsData } = useApplications("TENANTID");
  const { getBrandingInfo } = useTenantBranding("DATA");
  const { data: dataQuickLinks } = useQuickLinksConsole("SELECT_APP_DASHBOARD");
  const { data: dataAudit } = useAudit("DATA");
  const { data: dataBaseRoles } = useUserRole("DATA");
  const [selectSegment, setSelectSegment] = useState("");
  const [selectSegmentId, setSelectSegmentId] = useState("");
  const [selectEnvironmentId, setSelectEnvironmentId] = useState("");
  const [selectRoleId, setSelectRoleId] = useState("");
  const [isSelected, setIsSelected] = useState({});
  const [isSelectedSegment, setIsSelectedSegment] = useState({});
  const [isSelectedEnv, setIsSelectedEnv] = useState({});
  const [isSelectedRole, setIsSelectedRole] = useState({});
  const { getInfoChildrenTenants } = useTenants("CHILDREN");
  const [isExpandedRetail, setIsExpandedRetail] = useState(false);
  const [isExpandedCorporate, setIsExpandedCorporate] = useState(false);

  const [filteredDataEnvironments, setFilteredDataEnvironments] = useState<any | null>(null);
  const [filteredDataRoles, setFilteredDataRoles] = useState<any | null>(null);
  const [modalProps, setModalProps] = useState<DialogProps>({
    visible: false,
  } as DialogProps);
  const showAuditWidget = !!dataBaseRoles && !!dataBaseRoles[0]?.rolePermissions?.find(
    (rol: any) => (rol?.functionality?.code === "COD_AREP" && rol.permission.privilegeId === "READ"));

  const onSelectApp = async (app: AppInfo) => {
    const rolesListByAppId = applicationsData[0]?.segments?.filter((segItem: any) => segItem.appid === app.appid)[0]
      ?.environments?.filter((envItem: any) => envItem.environmentId === app.envid)[0]?.roles;

    setAppState((prev) => ({
      ...prev,
      isLoading: true,
      appRoles: rolesListByAppId?.length > 1
        ? rolesListByAppId
        : null,
    }));
    await auth.selectRoleAction(app.tenantid, app.appid, app.roleid, app.segment!, app.env);

    const agentStatus = await Promise.resolve(getAgent(app.agent))
      .then((response) => {
        IBModuleApi.defaults.baseURL =
          process.env.REACT_APP_BACKEND_HOST?.includes("localhost")
            ? process.env.REACT_APP_BACKEND_HOST
            : response.data.url;
        sessionStorage.setItem("ENV", app.env === "DEVELOP" ? "DEV" : app.env);
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });

    setAppState((prev) => ({
      ...prev,
      isLoading: false,
      selectedApp: agentStatus === "SUCCESS" ? app : null,
    }));

    window.scrollTo(0, 0);
  };

  const onAction = async () => {
    const tenant = applicationsData[0];
    const segment = applicationsData[0].segments
      ?.filter((segment: any) => segment.appid === selectSegmentId);

    const environment = segment
      ?.map((segment: any) => {
        return segment.environments
          ?.find((environment: any) => environment.name === selectEnvironmentId)
      })
      ?.filter(Boolean);

    const role = environment[0].roles
      ?.filter((role: any) => role.roleId === selectRoleId);

    onSelectApp({
      tenantid: tenant.uuid,
      tenantname: tenant.name,
      appid: segment[0].appid,
      segment: segment[0].segment,
      appname: segment[0].segmentname,
      agent: environment[0].agentId,
      env: environment[0].name,
      roleid: role[0].roleId,
      rolename: role[0].roleName,
      envid: environment[0].environmentId,
    })
  };

  const onReturn = async () => {
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const arrayNavigation: any = tenantIdListsNavigations?.length === 1 ? tenantIdListsNavigations : tenantIdListsNavigations.filter(item => item !== tenantIdListsNavigations[tenantIdListsNavigations.length - 1]);
    const tenant = await Promise.resolve(getInfoChildrenTenants(tenantId));

    setAppState((prev) => ({
      ...prev,
      tenantId: tenantId,
      selectedTenantId: null,
      tenantIdListsNavigations: arrayNavigation,
      tenantParentName: tenant[0].name,
    }));
    const dataBranding: DataBranding = await Promise.resolve(getBrandingInfo(tenantId));
    if (dataBranding) {
      setAppState((prev) => ({
        ...prev,
        dataBrandingObject: dataBranding,
      }));
    }
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
  }

  const handleChangeSelect = (e: any) => {
    if (e?.item?.label === selectSegment) {
      e.item.id === "RETAIL" ? setIsExpandedRetail(false) : setIsExpandedCorporate(false);
      setSelectSegment('');
      setIsSelected(objSegments);
      // Setear segmentos
      setSelectSegmentId('')
      setIsSelectedSegment(objTypesSegments);
      // Setear columna ambientes
      setSelectEnvironmentId('');
      setFilteredDataEnvironments(null);
      setIsSelectedEnv(objTypesEnvironments)
      // Setear columna roles
      setSelectRoleId('');
      setFilteredDataRoles(null);
      setIsSelectedRole(objTypesRoles);
    } else {
      if (e.item.items.length > 1) {
        setSelectSegment(e.item.label);
        e.item.id === "RETAIL" ? setIsExpandedRetail(true) : setIsExpandedCorporate(true);
        const obj = Object.defineProperty(objSegments, e.item.label, { value: 'selected' });
        setIsSelected(obj);
      } else {
        setSelectSegment(e.item.label);
        e.item.id === "RETAIL" ? setIsExpandedRetail(false) : setIsExpandedCorporate(false);
        const obj = Object.defineProperty(objSegments, e.item.label, { value: 'selected' });
        setIsSelected(obj);
        setSelectSegmentId(e.item.items[0].id);
        // Setear columna ambientes
        setSelectEnvironmentId('');
        setFilteredDataEnvironments(null);
        setIsSelectedEnv(objTypesEnvironments)
        // Setear columna roles
        setSelectRoleId('');
        setFilteredDataRoles(null);
        setIsSelectedRole(objTypesRoles);
      }
    }
  }

  const handleChangeSelectSegment = (e: any) => {
    if (e?.item?.id === selectSegmentId) {
      setSelectSegmentId('')
      setIsSelectedSegment(objTypesSegments);
      // Setear columna ambientes
      setSelectEnvironmentId('');
      setFilteredDataEnvironments(null);
      setIsSelectedEnv(objTypesEnvironments)
      // Setear columna roles
      setSelectRoleId('');
      setFilteredDataRoles(null);
      setIsSelectedRole(objTypesRoles);
      e.item.id === "RETAIL" ? setIsExpandedRetail(true) : setIsExpandedCorporate(true);
    } else {
      // Setear columna ambientes
      setSelectEnvironmentId('');
      setIsSelectedEnv(objTypesEnvironments);
      // Setear columna roles
      setFilteredDataRoles(null);
      setIsSelectedRole(objTypesRoles);
      // Seteamos el valor segmento que se selecciono
      setSelectSegmentId(e?.item?.id);
      const obj = Object.defineProperty(objTypesSegments, e.item.label, { value: 'selected' });
      setIsSelectedSegment(obj);
      e.item.id === "RETAIL" ? setIsExpandedRetail(true) : setIsExpandedCorporate(true);
    }
  }

  const handleChangeSelectEnvironment = (e: any) => {
    if (e?.node?.id === selectEnvironmentId) {
      setSelectEnvironmentId('');
      setIsSelectedEnv(objTypesEnvironments);
      // Setear columna roles
      setSelectRoleId('');
      setFilteredDataRoles(null);
      setIsSelectedRole(objTypesRoles);
    } else {
      // Setear columna roles
      setSelectRoleId('');
      setIsSelectedRole(objTypesRoles);
      // Seteamos el valor del ambiente que se selecciono
      setSelectEnvironmentId(e?.node?.id);
      const obj = Object.defineProperty(objTypesEnvironments, e.node.label, { value: 'selected' });
      setIsSelectedEnv(obj);
    }
  }

  const handleChangeSelectRole = (e: any) => {
    if (e?.node?.id === selectRoleId) {
      setSelectRoleId('');
      setIsSelectedRole(objTypesRoles);
      console.log('e?.node?.id === selectRoleId')
    } else {
      // Seteamos el valor del rol que se selecciono
      setSelectRoleId(e?.node?.id);
      const obj = Object.defineProperty(objTypesRoles, e.node.label, { value: 'selected' });
      setIsSelectedRole(obj);
      console.log('e?.node?.id === selectRoleId elsessssss')

    }
  }

  const handleModalProps = (actionType: "action" | "cancel") => {
    switch (actionType) {
      case "cancel":
        return setModalProps((prev) => ({
          ...prev,
          visible: true,
          title: t("AppSelector.cancelModalTitle"),
          content: t("AppSelector.cancelModalContent"),
          onConfirm: () => onReturn(),
        }));
      default:
        return;
    }
  };

  useEffect(() => {
    if (selectSegmentId) {
      const filterSegments = applicationsData?.map((segment: any) => segment.segments).flat();
      const filterEnviroments = filterSegments?.filter((segment: any) => segment.appid === selectSegmentId && segment.environments).flat()[0]?.environments;
      setFilteredDataEnvironments(filterEnviroments);
    }
    if (selectEnvironmentId) {
      // setFilteredDataRoles(rolesData);
      const filterSegments = applicationsData?.map((segment: any) => segment.segments).flat();
      const filterEnviroments = filterSegments?.filter((segment: any) => segment.appid === selectSegmentId && segment.environments).flat()[0]?.environments;
      const filterRoles = filterEnviroments?.filter((env: any) => env.name === selectEnvironmentId && env.roles)[0].roles;
      setFilteredDataRoles(filterRoles);
    }
  }, [selectSegmentId, selectEnvironmentId]);

  const columnsLastChanges = useMemo(() => {
    if (language) {
      return [
        {
          field: "creationDate",
          header: t("Dashboard.updatedAtLabel"),
        },
        {
          field: "functionality",
          header: t("Dashboard.functionalityLabel"),
        },
        {
          field: "userEmail",
          header: t("Dashboard.userLabel"),
        },
        {
          field: "activity",
          header: t("Dashboard.activityLabel"),
        },
      ];
    } else {
      return [];
    }
  }, [t, language]);

  const segmentsItems = applicationsData && [{}, ...[
    "RETAIL",
    "CORPORATE",
  ]
    .map((itemMain: any) => {
      if (applicationsData && applicationsData[0]?.segments.find((item: any) => item.segment === itemMain)) {
        return {
          id: itemMain,
          label: t(`AppSelector.${itemMain.toLowerCase()}Label`),
          items:
            applicationsData[0]?.segments
              .filter((item: any) => item.segment === itemMain)
              .map((item: any) => ({
                id: item.appid,
                label: item.segmentname,
                command: (e: any) => handleChangeSelectSegment(e),
                // @ts-ignore
                className: `segment-item-${isSelectedSegment[item.segmentname]}`
              })),
          expanded: itemMain === "RETAIL" ? isExpandedRetail : isExpandedCorporate,
          command: (e: any) => handleChangeSelect(e),
          // @ts-ignore
          className: `segment-item-main-${isSelected[t(`AppSelector.${itemMain.toLowerCase()}Label`)]}
            ${applicationsData &&
              applicationsData[0]?.segments.filter((item: any) => item.segment === itemMain).length === 1
              ? "segment-item-1" : ""
            }`
        }
      }
    })
    .filter((item: any) => item !== undefined)
  ];

  const [parentHasApplication, setParentHasApplication] = useState<boolean>(false);
  useEffect(() => {
    if (applicationsData) {
      const appListByTenant: boolean = ((applicationsData[0]?.segments?.length > 1)
        || (applicationsData[0]?.segments?.length === 1
          && applicationsData[0]?.segments[0]?.environments?.length > 1));
      setAppState((prev: any) => ({
        ...prev,
        showChangeAppButton: appListByTenant
      }));

      setParentHasApplication(!!isParentTenant && applicationsData?.length > 0);
    }
    else {
      setParentHasApplication(!!isParentTenant && applicationsData === null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationsData]);

  useEffect(() => {
    if (applicationsData) {
      const segments = applicationsData[0]?.segments;

      if (segments?.length === 1) {
        setSelectSegment(segments[0].segment);
        const obj = Object.defineProperty(objSegments, t(`AppSelector.${segments[0].segment.toLowerCase()}Label`), { value: 'selected' });
        setIsSelected(obj);
        setSelectSegmentId(segments[0].appid);

        if (segments[0].environments.length === 1) {
          setFilteredDataEnvironments(segments[0].environments);
          setSelectEnvironmentId(segments[0].environments[0].name);
          const obj = Object.defineProperty(objTypesEnvironments, segments[0].environments[0].name, { value: 'selected' });
          setIsSelectedEnv(obj);

          if (segments[0].environments[0].roles.length === 1) {
            setFilteredDataRoles(segments[0].environments[0].roles);
            setSelectRoleId(segments[0].environments[0].roles[0].roleId);
            const obj = Object.defineProperty(objTypesRoles, segments[0].environments[0].roles[0].roleName, { value: 'selected' });
            setIsSelectedRole(obj);
          }
        }
      }
    }
  }, [applicationsData, filteredDataRoles]);

  return (
    <div className="dashboard-external-container">
      {parentHasApplication &&
        <BoxFull
          className="flex px-0 py-5"
          variant="tertiary"
        >
          <div className="flex" style={{ position: "relative", left: "-1rem" }}>
            <Button
              variant="p-button-link"
              icon="iu iu-icon-left"
              label={t("AppSelector.selectApplicationClientTitle")}
              onClick={() => handleModalProps("cancel")}
            />
          </div>
        </BoxFull>
      }

      {hasApplications &&
        <BoxFull
          className="flex px-0 py-0"
          variant="tertiary"
        >
          <div className="treeboxes-title">
            <div className={`mb-4 pt-0 app-selector-subtitle ${!parentHasApplication ? 'selectapp-title' : ''}`}>{t('AppSelector.selectApplicationTitle').toUpperCase()}</div>
            <p className="selectapp-subtitle">{t('AppSelector.selectApplicationDescription')}</p>
          </div>
        </BoxFull>
      }

      {hasApplications &&
        <>
          <BoxFull className="pt-0 px-4 pb-5" style={{ backgroundColor: "transparent" }}>
            <div className={`container-treeboxes mt-4`} id='PreparationFormContainer'>
              <div className={`treeboxes-child general-form start`}>
                <div className="app-selector-subtitle">
                  <div>{t('AppSelector.selectSegmentLabel')}</div>
                </div>
                <div className="treeboxes-item treeboxes-item__gray" style={{ height: '80%' }} id='SelectAppContainer'>
                  {applicationsData?.length > 0
                    ?
                    <PerfectScrollbar>
                      <div className="segments-items">
                        <PanelMenu model={segmentsItems} />
                      </div>
                    </PerfectScrollbar>
                    :
                    <div className="skeleton-items-container"></div>
                  }
                </div>
              </div>
              <div className={`treeboxes-child general-form mid`}>
                <div className="app-selector-subtitle">
                  <div>{t('AppSelector.selectEnvironmentLabel')}</div>
                </div>
                <div className="treeboxes-item tabletsecond treeboxes-item__white flex flex-column" style={{ height: '80%' }} id='SelectAppContainer'>
                  {applicationsData?.length > 0
                    ?
                    <>
                      {filteredDataEnvironments ?
                        <PerfectScrollbar>
                          <div className="envs-items">
                            <TreeSelection
                              id='TransferTypesContainer'
                              children={<></>}
                              value={filteredDataEnvironments
                                ?.map((env: any) => {
                                  return {
                                    id: env.name,
                                    label: env.name,
                                    // @ts-ignore
                                    className: `app-card-${isSelectedEnv[env.name]}`
                                  }
                                })
                                .sort(
                                  (a: any, b: any) => a.label.localeCompare(b.label))
                              }
                              selectionMode='single'
                              selectionKeys={selectEnvironmentId}
                              onSelect={(e: any) => handleChangeSelectEnvironment(e)}
                              style={{ margin: '0 auto' }}
                              className='col-8'
                            />
                          </div>
                        </PerfectScrollbar>
                        :
                        <div className="select-role-description">
                          {t('AppSelector.selectEnvironmentDescription')}
                        </div>
                      }
                    </>
                    :
                    <div className="skeleton-items-container" style={{ backgroundColor: "#eee" }}></div>
                  }
                </div>
              </div>
              <div className={`treeboxes-child general-form end`}>
                <div className="app-selector-subtitle">
                  <div>{t('AppSelector.selectRoleLabel')}</div>
                </div>
                <div className="treeboxes-item tabletsecond treeboxes-item__gray flex flex-column" style={{ height: '80%' }} id='SelectAppContainer'>
                  {applicationsData?.length > 0
                    ?
                    <>
                      {filteredDataRoles ?
                        <PerfectScrollbar>
                          <div className="envs-items">
                            <TreeSelection
                              id='TransferTypesContainer'
                              children={<></>}
                              value={filteredDataRoles
                                ?.filter((rol: any) => rol.statusId !== 'DELETED')
                                ?.map((rol: any) => {
                                  return {
                                    id: rol.roleId,
                                    label: rol.roleName,
                                    // @ts-ignore
                                    className: `app-card-${isSelectedRole[rol.roleName]}`
                                  }
                                })}
                              selectionMode='single'
                              selectionKeys={selectRoleId}
                              onSelect={(e: any) => handleChangeSelectRole(e)}
                              style={{ margin: '0 auto' }}
                              className='col-8 py-0'
                            />
                          </div>
                        </PerfectScrollbar>
                        :
                        <div className="select-role-description">
                          {t('AppSelector.selectRoleDescription')}
                        </div>
                      }
                    </>
                    :
                    <div className="skeleton-items-container"></div>
                  }
                </div>
              </div>
            </div>
          </BoxFull>

          <BoxFull className="pt-0 px-4 pb-0 mb-3" style={{ backgroundColor: "transparent" }}>
            <div className="flex align-items-center justify-content-end gap-5">
              <Button
                variant="p-button"
                label={t("AppSelector.getIntoBtnLabel")}
                disabled={selectSegmentId && selectEnvironmentId && selectRoleId ? false : true}
                onClick={() => onAction()}
              />
            </div>
          </BoxFull>
        </>
      }

      {(dataAudit?.length > 0 || dataQuickLinks?.length > 0) &&
        <BoxFull className="p-0" variant="tertiary">
          <div className={`config-grid-1 ${applicationsData === null && "mt-0"}`}>
            {dataAudit?.length > 0 && showAuditWidget && <LastChangesTable
              title={t("Dashboard.latestChangesTitle")}
              data={dataAudit}
              columns={columnsLastChanges}
            />}
            {dataQuickLinks?.length > 0 && <SettingsUsed
              title={t("Dashboard.mostUsedConfigurationsTitle")}
              data={dataQuickLinks}
            />}
          </div>
        </BoxFull>
      }

      <CustomDialog
        title={modalProps.title}
        visible={modalProps.visible}
        content={modalProps.content}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
      />
    </div>
  );
};
